import styled from 'styled-components';

export default styled.div`
	display: flex;
	align-items: center;
	gap: var(--spacing-xx-small);
	max-width: 100%;
`;
